import createStyles from "@material-ui/core/styles/createStyles";
import { lighten } from "@material-ui/core/styles/colorManipulator";

import { Theme } from "@material-ui/core";

export const styles = ({palette, spacing}: Theme) => createStyles({

    card: {
        maxWidth: 280,
        marginRight: "auto",
        marginLeft: "auto"
    },
    header: {
        backgroundColor: lighten(`${palette.secondary.main}`, 0.3),
        padding: `${spacing.unit * 1.5}px ${spacing.unit * 3}px`
    },
    title: {
        fontWeight: 600
    },
    date: {
        textTransform: "uppercase"
    },
    icon: {
        marginRight: spacing.unit * 1.5,
    },
    status: {
        display: "flex",
        alignItems: "center",
        marginBottom: spacing.unit * 1.5,
    },

    actions: {
        alignItems: "flex-end",
        justifyContent: "flex-end"
    }

});


// WEBPACK FOOTER //
// ./src/components/QuotationCard/QuotationCard.style.tsx